<template>
  <h1>Cancha</h1>
</template>

<script>
export default {
  name: 'Cancha',
};
</script>

<style scoped></style>
